/**
 * Shared light/dark --pp-* token CSS for partner signup / auth shells.
 * Use inside a styled-components Page root that also has className "auth-light-page".
 */
export const partnerSignupThemeVars = `
  --pp-brand: #00AEEF;
  --pp-brand-bg: #e0f7ff;
  --pp-brand-border: #7dd3fc;
  --pp-surface: #ffffff;
  --pp-text: #0f172a;
  --pp-muted: #0891b2;
  --pp-border: #e2e8f0;
  --pp-dark: #0f172a;
  --pp-dark-muted: #0e7490;
  --pp-radius-card: 12px;
  --pp-radius-btn: 8px;
  --pp-error-bg: #fef2f2;
  --pp-error-text: #b91c1c;
  --pp-error-border: #fecaca;
  --pp-success-bg: #ecfdf5;
  --pp-success-text: #047857;
  --pp-success-border: #a7f3d0;
  --pp-warn-bg: #fffbeb;
  --pp-warn-border: #fde68a;
  --pp-input-muted-bg: #f8fafc;

  color-scheme: light;

  html.dark &,
  body.app-dark-theme & {
    --pp-brand: #00AEEF;
    --pp-brand-bg: rgba(0, 174, 239, 0.14);
    --pp-brand-border: rgba(125, 211, 252, 0.35);
    --pp-surface: var(--sp-bg-card, #161c27);
    --pp-text: var(--sp-ink, #f0f4ff);
    --pp-muted: #7dd3fc;
    --pp-border: var(--sp-border, #1e293b);
    /* Keep hero panel tokens dark regardless of app theme */
    --pp-dark: #0f172a;
    --pp-dark-muted: #7dd3fc;
    --pp-error-bg: rgba(185, 28, 28, 0.18);
    --pp-error-text: #fca5a5;
    --pp-error-border: rgba(252, 165, 165, 0.35);
    --pp-success-bg: rgba(4, 120, 87, 0.18);
    --pp-success-text: #6ee7b7;
    --pp-success-border: rgba(110, 231, 183, 0.35);
    --pp-warn-bg: rgba(245, 158, 11, 0.14);
    --pp-warn-border: rgba(251, 191, 36, 0.35);
    --pp-input-muted-bg: var(--sp-bg-surface, #1c2333);
    color-scheme: dark;
  }
`;
